export default "__VITE_ASSET__Dn6vN8Td__"